<div class="emr-detail-access-info-container">
  <div class="leftColumn">
    <app-list-summary [summaryItems]="summaryItems"></app-list-summary>
    <retrieval-access-info-view-edit [retrievalId] ="retrievalId"></retrieval-access-info-view-edit>
</div>
</div>
